module.exports = __webpack_public_path__ + "fe7a9b468c5c9cdd099254d19f1befbd.svg";